// Tenant permission copy: what a page says when an admin has set this user's
// permission for it to No on the Permissions screen. Not a plan limit, so it
// never offers an upgrade.

export const permissionsCopy = {
  noAccess: {
    reports: "Your administrator hasn't given you access to reports.",
  },
  howToChange: 'A tenant admin can change this on the Permissions screen.',
} as const;
